export default function IndexSection() {
  const items = [
    { icon: 'ri-fire-line', title: '今日热搜榜', desc: '实时追踪全网最热话题，每分钟更新排名', color: 'text-primary-500', bg: 'bg-primary-100' },
    { icon: 'ri-star-line', title: '明星动态', desc: '爱豆最新行程、作品和日常一手掌握', color: 'text-accent-500', bg: 'bg-accent-100' },
    { icon: 'ri-movie-line', title: '影视情报站', desc: '新片定档、剧组路透、票房数据全收录', color: 'text-secondary-500', bg: 'bg-secondary-100' },
    { icon: 'ri-music-line', title: '音乐风向标', desc: '新歌首发、演唱会资讯、音乐人专访', color: 'text-primary-500', bg: 'bg-primary-100' },
    { icon: 'ri-live-line', title: '综艺万花筒', desc: '录制花絮、嘉宾爆料、节目名场面合集', color: 'text-accent-500', bg: 'bg-accent-100' },
    { icon: 'ri-t-shirt-line', title: '时尚穿搭志', desc: '明星街拍、红毯造型、潮流趋势解读', color: 'text-secondary-500', bg: 'bg-secondary-100' },
    { icon: 'ri-emotion-line', title: '瓜田深度扒', desc: '深度挖掘娱乐事件背后的来龙去脉', color: 'text-primary-500', bg: 'bg-primary-100' },
    { icon: 'ri-calendar-check-line', title: '每日速递', desc: '当天最新爆料汇总，不错过任何一个大瓜', color: 'text-accent-500', bg: 'bg-accent-100' },
  ];

  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          专题合集
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.map((item) => (
            <div key={item.title} className="bg-background-50 rounded-xl p-5 group cursor-pointer transition-all hover:-translate-y-1 text-center">
              <div className={`w-12 h-12 mx-auto mb-3 rounded-xl ${item.bg} flex items-center justify-center`}>
                <i className={`${item.icon} text-xl ${item.color}`}></i>
              </div>
              <h3 className="text-sm font-heading text-foreground-900 mb-1 whitespace-nowrap">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}